import React from "react";
import SignatureLogo from 'assets/img/Signature Logo.png';
import ThriveSignaturegep from 'assets/img/Thrive Signaturegep.png';

const WelcomeMessage = () => {
    return (
        <div
            style={{
                textAlign: "center",
                color: "#4a4a4a",
                padding: "30px",
                fontSize: "15px",
                lineHeight: "1.7",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                width:"70%",
                margin:"auto"              
            }}
        >
            <div>
                <img  style={{ width: "400px", textAlign: "center", marginTop: "20px" }} src={ThriveSignaturegep}  alt=""  />
                <p style={{ fontWeight: "bold", color: "#333", marginBottom: "20px" }}>
                    Welcome to the Henry Schein Thrive Signature Community!
                </p>
                <p style={{ marginBottom: "20px" }}>
                    We are delighted to welcome you as a valued member. Should you have any
                    questions or need guidance in maximizing your benefits, our dedicated
                    concierge team is at your service. Call us at <strong>833.473.4968, Option 2</strong>.
                    We’re always ready to help you navigate and make the most of your Thrive
                    Signature experience!
                </p>
                <p>We are committed to supporting the success of your practice!</p>
            </div>
        </div>
    );
};

export default WelcomeMessage;